import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { Translate } from '@decorators';

import { IBrandPageProps } from '../../types';

import * as s from './BrandFooter.scss';

@Translate('common.containers.Brand.components.BrandFooter')
export class BrandFooter extends React.Component<IBrandPageProps> {

	shouldComponentUpdate(): boolean {
		return false;
	}

	render() {
		const {
			urls,
			classNames: {
				content: contentClassName,
			},
		} = this.props;
		const { copyright } = getConfig();

		return (
			<div className={s.block}>
				<div className={cn(s.content, contentClassName)}>
					<div className={s.links}>
						<a
							className={s.link}
							href={urls.feedback}
							target="_blank"
							rel="noopener noreferrer"
						>
							{this.t('feedback')}
						</a>
					</div>

					<div className={s.copyright}>{copyright}</div>
				</div>
			</div>
		);
	}

}
